import { render, staticRenderFns } from "./reduction-apply.vue?vue&type=template&id=0aa139be"
import script from "./reduction-apply.vue?vue&type=script&lang=ts"
export * from "./reduction-apply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports